export const getLauncher = () => {
	return (window as any).hashUpLauncher;
};

export const isLauncher = () => {
	return !!getLauncher();
};

export const handleOsInstall = () => {
	window.location.replace('https://dl.patchkit.net/d/3sxi7923gq5eccqh7tlzo/direct');
};
